import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { WilsonMark } from "./WilsonMark";
const TONE_CLASS = {
  info: "bg-tone-blue text-tag-ink",
  warn: "bg-tone-peach text-tag-ink",
  yellow: "bg-tone-yellow text-tag-ink",
  critical: "bg-tone-red text-tone-red-ink",
  wilson: "bg-cobalt-pale/35 text-ink"
} as const;
export function Callout({
  tone,
  children,
  action,
  className
}: {
  tone: keyof typeof TONE_CLASS;
  children: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return <div className={cn("flex items-center gap-2.5 rounded-field px-3.5 py-2.5 text-callout leading-[1.45]", TONE_CLASS[tone], className)} role={tone === "critical" ? "alert" : undefined} data-sentry-component="Callout" data-sentry-source-file="Callout.tsx">
            {tone === "wilson" && <WilsonMark placement="rail" />}
            <div className="flex-1 min-w-0">{children}</div>
            {action && <div className="flex-shrink-0">{action}</div>}
        </div>;
}